import { Modal, Button, Tooltip, Input } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { supabase } from '../Utils/SupabaseClient';
import { AES } from "crypto-js";

export default function ClipBoardModal(props) {

  const { TextArea } = Input;

  const [textAreaValue, settextAreaValue] = useState("");
  const [modalVisible, setmodalVisible] = useState(false);
  const [okButtonLoading, setokButtonLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleAddFromClipboard = () => {
    navigator.clipboard
      .readText()
      .then((text) => {
        settextAreaValue(text);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
      });
  };

  const showModal = () => {
    setmodalVisible(true);
  };
  
  const encryptText = (text) => {
    const authenticatedDetails = JSON.parse(localStorage.getItem("sb-vzjsvtytmwtjveoozozm-auth-token"));
    const user = authenticatedDetails['user'];
    return AES.encrypt(text, user.email).toString();
    // return text;
  };

  const handleOk = async () => {
    setokButtonLoading(true);

    await supabase
      .from('notes')
      .insert({ data: encryptText(textAreaValue) })
      .select();

    setokButtonLoading(false);
    setmodalVisible(false);
    settextAreaValue("");
    props.refresh();
  };

  const handleCancel = () => {
    setmodalVisible(false);
  };
  const onTextAreaValueChange = ({ target: { value } }) => {
    settextAreaValue(value);
  };

  return (
    <>
      <Tooltip title="Add Clip">
        <Button
          shape="circle"
          type="primary"
          onClick={showModal}
          size="large"
          icon={<PlusCircleOutlined />}
        />
      </Tooltip>
      <Modal
        visible={modalVisible}
        title="Add Clip"
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={okButtonLoading}
            onClick={handleOk}
          >
            Add this Clip
          </Button>,
        ]}
      >
        {error ? (
          <p>Some Error Occuerd</p>
        ) : (
          <>
            <Button
              key="back"
              type="dashed"
              block
              onClick={handleAddFromClipboard}
            >
              Add From ClipBoard
            </Button>
            <TextArea
              value={textAreaValue}
              onChange={onTextAreaValueChange}
              autoSize={{ minRows: 3, maxRows: 15 }}
            />
          </>
        )}
      </Modal>
    </>
  );
}
